import { CreateBrandedEnum, type ZodInfer } from '@mntn-dev/utility-types'

export const [Units, UnitSchema, UnitEnum, unbrandUnit] = CreateBrandedEnum(
  { brand: 'Unit' },
  'mntn_credits',
  'tiktok',
  'meta',
  'linkedin',
  'USD'
)

export type Unit = ZodInfer<typeof UnitSchema>

export const Unit = (input: string): Unit =>
  UnitSchema.catch(UnitEnum.USD).parse(input)
